<p>
  Известията в платформата ви информират за важни действия, свързани с вашите обяви, покупки, съобщения и взаимодействия
  с други потребители. Те ви помагат да не пропускате нищо важно, но също така могат да бъдат персонализирани така, че
  да не получавате излишна информация.
</p>
<h6 class="mt-3">Какви типове известия се предлагат?</h6>
<p class="mb-1">
  Всяко известие може да бъде получено по два начина:
</p>
<ul>
  <li>Като <strong>електронна поща</strong> – съобщение, изпратено директно във входящата ви поща;</li>
  <li>Като <strong>известие в платформата</strong> – налично в секцията <strong>„Профил“ → „Известия“</strong>.</li>
</ul>
<h6 class="mt-3">Най-често срещаните известия включват:</h6>
<ul>
  <li>Добавяне, редактиране или премахване на обява</li>
  <li>Потвърждение на покупка или наддаване</li>
  <li>Завършване на обява със или без сделка</li>
  <li>Спечелване на търг</li>
  <li>Получаване на ценово предложение или приемане на ваше</li>
  <li>Получаване на ново съобщение, отзив или коментар</li>
  <li>Активност от други потребители в аукцион (напр. надмината оферта)</li>
</ul>
<h6 class="mt-3">Как да управлявате известията си?</h6>
<ol>
  <li>Отидете на <strong>„Профил“</strong> → <strong>„Настройки“</strong>.</li>
  <li>Превъртете до секцията <strong>„Настройки на известията“</strong>.</li>
  <li>
    За всяка отделна ситуация може да изберете:
    <ul>
      <li><em>Получаване чрез електронна поща</em></li>
      <li><em>Получаване чрез известие в платформата</em></li>
    </ul>
  </li>
  <li>Промените се записват автоматично – не е необходимо допълнително потвърждение.</li>
</ol>
<h6 class="mt-3">Къде да откриете известията си?</h6>
<p>
  Всички съобщения, които сте избрали да получавате в платформата, се съхраняват в <strong>„Профил“ →
  „Известия“</strong>. Там може да преглеждате историята на действията, да отваряте свързаното съдържание и да следите
  активността по обявите си.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Ако предпочитате по-малко имейли, може да изключите имейл известията и да използвате само
  известията в платформата. Така ще останете информирани, без да натоварвате пощата си.
</div>
